module.exports = __webpack_public_path__ + "static/media/006_security_warning.27f3a63e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/vmware/006_security_warning.png
// module id = 639
// module chunks = 0